import { initAnalytics, isAnalyticsDefined } from '../../container/widgets-container'
import { Promiseable, retryWithTimeout } from '../../utils/retry'
import { AnalyticsController, AnalyticsService, PixelEvent } from './types'

const trackRetries = 10
const trackRetriesIntervalMs = 50
const reportingEndPoints = ['p.yotpo.com']
const apiId = 'onsite_v3'

export class YotpoAnalytics {
  static track (guid: string, event: PixelEvent): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      YotpoAnalytics.doTrack(guid, event, trackRetries, trackRetriesIntervalMs, resolve, reject)
    })
  }

  static getUniqueUserIdentifier (guid: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      YotpoAnalytics.doGetUniqueUserIdentifier(guid, trackRetries, trackRetriesIntervalMs, resolve, reject)
    })
  }

  private static doGetUniqueUserIdentifier (guid: string, retryCount: number, retryInterval: number, resolve: any, reject: any): void {
    const action: Promiseable = {
      do: () => {
        return YotpoAnalytics.doGetUserId(guid)
      },
      checker: (): boolean => {
        return YotpoAnalytics.isYotpoAnalyticsExists()
      },
      resolve: (data: any) => {
        resolve(data)
      },
      reject: () => {
        reject('timeout waiting for analytics')
      }
    }
    retryWithTimeout(action, retryInterval, retryCount)
  }

  private static isYotpoAnalyticsExists (): boolean {
    return isAnalyticsDefined()
  }

  private static doTrack (guid: string, event: PixelEvent, retryCount: number, retryInterval: number, resolve: any, reject: any) {
    const action: Promiseable = {
      do: () => {
        const service = YotpoAnalytics.getAnalyticsService(guid)
        service.trackEvent(event.category, event.action, event.label, event.property, event.context)
        return true
      },
      checker: (): boolean => {
        return YotpoAnalytics.isYotpoAnalyticsExists()
      },
      resolve: (data: any) => {
        resolve(data)
      },
      reject: () => {
        reject('timeout waiting for analytics')
      }
    }
    retryWithTimeout(action, retryInterval, retryCount)
  }

  private static getController (guid: string): AnalyticsController {
    const userSettings: any = {
      reporting_end_points: reportingEndPoints
    }
    return {
      getAnalyticsVersion (): string {
        return apiId
      },
      getUserSetting (key: string): string {
        return userSettings[key]
      },
      getAppKey (): string {
        return guid
      }
    }
  }

  private static getAnalyticsService (guid: string): AnalyticsService {
    const analyticsController = YotpoAnalytics.getController(guid)
    return initAnalytics(analyticsController)
  }

  private static doGetUserId (guid: string) {
    const service = YotpoAnalytics.getAnalyticsService(guid)
    return service.getDomainUserId()
  }
}
